"use client";

import { useEffect, useState } from "react";
import {
  USE_CASES,
  USE_CASES_EYEBROW,
  USE_CASES_PROOF,
  USE_CASES_TITLE,
} from "@/lib/masterclass";
import { cn } from "@/lib/utils";

// ============================================================================
// Avant / après, tâche par tâche — les cas d'usage défilent.
//   Le lecteur se reconnaît dans une ligne, pas dans un tableau : on en met une
//   en avant à la fois et on tourne. Des DURÉES seulement, jamais d'euros.
//   Le défilement s'arrête si le visiteur clique une tâche (il pilote alors),
//   et ne démarre pas du tout si le système demande moins d'animation.
// ============================================================================

const ROTATE_MS = 3800;

export function UseCases() {
  const [i, setI] = useState(0);
  const [held, setHeld] = useState(false);

  useEffect(() => {
    if (held) return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    const id = window.setInterval(
      () => setI((n) => (n + 1) % USE_CASES.length),
      ROTATE_MS
    );
    return () => window.clearInterval(id);
  }, [held]);

  const c = USE_CASES[i];

  return (
    <>
      <p className="text-xs font-semibold uppercase tracking-wide text-brand">
        {USE_CASES_EYEBROW}
      </p>
      <h2 className="mt-2 text-balance text-[26px] font-extrabold leading-tight tracking-tight sm:text-[32px]">
        {USE_CASES_TITLE}
      </h2>

      {/* La carte active */}
      <div className="mt-6 rounded-2xl border border-ink/10 bg-white p-5 sm:p-6">
        <p className="text-sm font-semibold text-ink">{c.task}</p>

        <div className="mt-4 flex items-center gap-4">
          <div className="flex-1 rounded-xl bg-ink/[0.04] px-3 py-3 text-center">
            <div className="text-[10px] font-medium uppercase tracking-wide text-ink/40">
              avant
            </div>
            <div className="mt-1 text-xl font-extrabold text-ink/40 line-through tabular-nums sm:text-2xl">
              {c.before}
            </div>
          </div>
          <span className="shrink-0 text-lg text-ink/25" aria-hidden>
            →
          </span>
          <div className="flex-1 rounded-xl bg-brand/10 px-3 py-3 text-center">
            <div className="text-[10px] font-medium uppercase tracking-wide text-brand/70">
              après
            </div>
            <div className="mt-1 text-xl font-extrabold text-brand tabular-nums sm:text-2xl">
              {c.after}
            </div>
          </div>
        </div>

        <p className="mt-4 text-sm leading-relaxed text-ink/65">{c.note}</p>
      </div>

      {/* Les autres tâches, cliquables */}
      <div className="mt-4 flex flex-wrap gap-2">
        {USE_CASES.map((u, n) => (
          <button
            key={u.task}
            type="button"
            onClick={() => {
              setI(n);
              setHeld(true);
            }}
            aria-current={n === i}
            className={cn(
              "cursor-pointer rounded-full border px-3 py-1.5 text-xs font-medium transition",
              n === i
                ? "border-brand bg-brand/10 text-brand"
                : "border-ink/12 bg-white text-ink/55 hover:border-brand/40 hover:text-ink"
            )}
          >
            {u.task}
          </button>
        ))}
      </div>

      <p className="mt-6 text-sm leading-relaxed text-ink/60">{USE_CASES_PROOF}</p>
    </>
  );
}
